module.exports = __webpack_public_path__ + "static/media/chicago.54236170.jpeg";